import type {
	SRT_ColumnDef,
	SRT_RowData,
	SRT_StatefulTableOptions,
} from '../../types'

import { SRT_ToggleRowActionMenuButton } from '../../components/buttons/SRT_ToggleRowActionMenuButton'
import { defaultDisplayColumnProps } from '../../utils/displayColumn.utils'

export const getSRT_RowActionsColumnDef = <TData extends SRT_RowData>(
	tableOptions: SRT_StatefulTableOptions<TData>
): SRT_ColumnDef<TData> => ({
	Cell: ({ cell, row, staticRowIndex, table }) => (
		<SRT_ToggleRowActionMenuButton
			cell={cell}
			row={row}
			staticRowIndex={staticRowIndex}
			table={table}
		/>
	),
	...defaultDisplayColumnProps({
		header: 'actions',
		id: 'srt-row-actions',
		size: 45,
		tableOptions,
	}),
})
